import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { GetList } from "../../StateManagement/Reducers/HealthProfileState";

import TopNav from "../TopNav";
import Lists from "./Lists";
import Loading from "../StyledComponents/Loading";

import { BodyContainer } from "../StyledComponents";
import {
  SubHeading,
  DropDown,
  DropDownListContainer,
  DropDownList,
  ListItem,
  Div,
} from "./styles";

import { AiOutlineDown } from "react-icons/ai";

const HealthProfile = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const inputNotRef = useRef(null);

  const [dropDown, setDropDown] = useState(false);
  const [selectedItem, setSelectedItem] = useState(
    state
      ? state.type.type === "medication"
        ? "Medication"
        : state.type.type === "medical_problem"
          ? "Problems"
          : state.type.type === "allergy"
            ? "Allergies"
            : "Lab Orders"
      : "Problems",
  );
  const [type, setType] = useState(
    state
      ? state.type.type === "medication"
        ? "medication"
        : state.type.type === "medical_problem"
          ? "medical_problem"
          : state.type.type === "allergy"
            ? "allergy"
            : "lab"
      : "medical_problem",
  );

  let accountType =
    localStorage.getItem("account_type") &&
    Decrypt_Value(localStorage.getItem("account_type"), "vozoportal");

  const Items =
    accountType === -1
      ? ["Problems", "Allergies", "Medication"]
      : ["Problems", "Allergies", "Lab Orders", "Medication"];

  const LoadingRes = useSelector((state) => state.HealthProfile.HealthLoading);

  const Toggling = () => setDropDown((prevState) => !prevState);

  const ClickedItem = (item) => () => {
    setSelectedItem(item);
    setDropDown((prevState) => !prevState);

    if (item === "Problems") {
      setType("medical_problem");
    } else if (item === "Allergies") {
      setType("allergy");
    } else if (item === "Medication") {
      setType("medication");
    } else {
      setType("lab");
    }
  };

  const handleClick1 = (e) => {
    if (inputNotRef.current && !inputNotRef.current.contains(e.target)) {
      setDropDown(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mouseup", handleClick1);

    return () => {
      document.addEventListener("mouseup", handleClick1);
    };
  }, []);

  useEffect(() => {
    dispatch(GetList(type));
  }, [type]);

  return (
    <>
      <TopNav title="Health Profile" />
      {LoadingRes ? (
        <Loading />
      ) : (
        <BodyContainer
          paddingLeft="10px"
          paddingTop="2px"
          style={{
            background: "#F3F4F6",
            minHeight: "100vh",
          }}
        >
          {/* <DropDown ref={inputNotRef}>
            <Div onClick={Toggling}>
              {`${selectedItem} List` || "Problems List"}
              <AiOutlineDown />
            </Div>

            {dropDown && (
              <DropDownListContainer>
                <DropDownList>
                  {Items.map((Item, ind) => (
                    <ListItem
                      onClick={ClickedItem(Item)}
                      key={ind}
                      id={`hltpr_li-hpl${ind}`}
                    >
                      {Item}
                    </ListItem>
                  ))}
                </DropDownList>
              </DropDownListContainer>
            )}
          </DropDown> */}

          {/* <div
            style={{
              background: "#FFFFFF",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
            }}
          > */}
          <div
            style={{
              display: "flex",
              gap: "24px",
              marginBottom: "2px",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            {Items.map((item, index) => {
              const formattedType =
                item === "Problems"
                  ? "medical_problem"
                  : item === "Allergies"
                    ? "allergy"
                    : item === "Medication"
                      ? "medication"
                      : "lab";

              const isActive = type === formattedType;

              return (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedItem(item);
                    setType(formattedType);
                  }}
                  style={{
                    cursor: "pointer",
                    paddingBottom: "6px",
                    fontWeight: isActive ? "600" : "400",
                    color: isActive ? "#2563EB" : "#6B7280",
                    borderBottom: isActive
                      ? "2px solid #2563EB"
                      : "2px solid transparent",
                    transition: "0.2s ease",
                  }}
                >
                  {item}
                </div>
              );
            })}
          </div>

          <Lists list={selectedItem} />
          {/* </div> */}
        </BodyContainer>
      )}
    </>
  );
};

export default HealthProfile;
